<script lang="ts">
	import Twitter from '$lib/components/editor/share/Twitter.svelte';
	import Facebook from './Facebook.svelte';
	import WhatsApp from './WhatsApp.svelte';
	import Telegram from './Telegram.svelte';
	import { onMount } from 'svelte';
	import CopyIcon from '$lib/components/common/CopyIcon.svelte';

	export let post_slug: string;
	export let title: string;
	let showToast: boolean = false;
	let copiedUrl: string = '';
	let isModalOpen: boolean = false;

	const siteUrl = 'https://bloomnetwork.earth/view';

	function constructUrl() {
		copiedUrl = `${siteUrl}/${post_slug}`;
	}

	function copyToClipboard() {
		// console.log('copyToClipboard started');
		constructUrl();
		navigator.clipboard
			.writeText(copiedUrl)
			.then(() => {
				showToast = true;
				// Wait for toast to disappear before closing modal
				setTimeout(() => {
					showToast = false;
					closeModal();
				}, 3000); // Show "Copied!" message for 3 seconds
			})
			.catch((err) => {
				console.error('Failed to copy:', err);
			});
	}

	onMount(() => {
		constructUrl();
	});

	function toggleModal() {
		isModalOpen = !isModalOpen;
	}

	function closeModal() {
		if (!showToast) {
			isModalOpen = false;
		}
	}

	function shareToInstagram() {
		copyToClipboard();
		alert(
			'Link copied! Add it to your Instagram post with a photo. Insta doesnt allow direct posting from other networks :/'
		);
	}
</script>

<aside aria-label="Share buttons" class="container">
	<div class="wrapper relative">
		<button
			class="my-0 bg-gradientBlue text-cosmicPurple800 font-exo-2 font-bold rounded-full"
			on:click={toggleModal}>Share</button
		>

		{#if isModalOpen}
			<button
				class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50 border-none"
				on:click={closeModal}
				on:keyup={(e) => {
					if (e.key === 'Enter' || e.key === 'Escape') closeModal();
				}}
				aria-label="Close share modal"
			>
				<div
					class="bg-cosmicMagenta400 rounded-lg p-6 w-[300px] lg:w-[400px] max-w-[90%] shadow-lg relative"
				>
					<button
						class="absolute -top-2 right-2 text-cosmicPurple100 hover:text-gray-300 font-exo-2 font-semibold border-none text-xl 3xl:text-2xl"
						on:click={closeModal}>x</button
					>
					<div class="space-y-4 mt-4">
						<div class="buttons relative">
							<button
								class="block w-full px-4 py-1 text-white bg-cosmicPurple800 rounded-md hover:bg-cosmicPurple600 focus:outline-none border-black"
							>
								<Twitter url={copiedUrl} {title} />
							</button>
							<button
								class="block w-full px-4 py-4 text-white bg-cosmicPurple800 rounded-md hover:bg-cosmicPurple600 focus:outline-none border-black"
								on:click={shareToInstagram}
							>
								Share on Instagram
							</button>
							<button
								class="block w-full px-4 py-1 text-white bg-cosmicPurple800 rounded-md hover:bg-cosmicPurple600 focus:outline-none border-black"
							>
								<Facebook url={copiedUrl} {title} />
							</button>
							<button
								class="block w-full px-4 py-1 text-white bg-cosmicPurple800 rounded-md hover:bg-cosmicPurple600 focus:outline-none border-black"
							>
								<WhatsApp url={copiedUrl} {title} />
							</button>
							<button
								class="block w-full px-4 py-1 text-white bg-cosmicPurple800 rounded-md hover:bg-cosmicPurple600 focus:outline-none border-black"
							>
								<Telegram url={copiedUrl} {title} />
							</button>
							<button
								class="w-full px-4 py-2 text-white bg-cosmicPurple800 rounded-md hover:bg-cosmicPurple600 focus:outline-none border-black flex items-center justify-center gap-2"
								on:click={copyToClipboard}
							>
								<span>Copy Link</span>
								<CopyIcon />
							</button>
						</div>
					</div>
				</div>
			</button>
		{/if}

		{#if showToast}
			<div
				class="absolute -bottom-12 left-1/2 transform -translate-x-1/2 bg-cosmicMagenta400 text-white py-2 px-4 rounded-full"
			>
				Copied
			</div>
		{/if}
	</div>
</aside>
